var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.5L4.29289 14.7929L3.58579 15.5L4.29289 16.2071L5 15.5ZM23.75 16.5C24.3023 16.5 24.75 16.0523 24.75 15.5C24.75 14.9477 24.3023 14.5 23.75 14.5V16.5ZM11.7929 7.29289L4.29289 14.7929L5.70711 16.2071L13.2071 8.70711L11.7929 7.29289ZM4.29289 16.2071L11.7929 23.7071L13.2071 22.2929L5.70711 14.7929L4.29289 16.2071ZM5 16.5H23.75V14.5H5V16.5Z",
    fill: "#1B1836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackCheckout);
export default __webpack_public_path__ + "static/media/back_checkout.8a548660eacbcf3bac268dbdd3068b38.svg";
export { ForwardRef as ReactComponent };